function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.902 13.543)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M233.779,280.941H219.821a1.571,1.571,0,0,1-1.571-1.571c0-5.816-2.377-10.9-7.479-16a22.67,22.67,0,1,1,32.06,0c-5.1,5.1-7.48,10.188-7.48,16A1.571,1.571,0,0,1,233.779,280.941Zm-12.44-3.143h10.922a22.659,22.659,0,0,1,2.5-8.906,31.307,31.307,0,0,1,5.843-7.75,19.527,19.527,0,1,0-27.616,0,31.276,31.276,0,0,1,5.843,7.75A22.655,22.655,0,0,1,221.339,277.8Z",
  transform: "translate(-204.13 -224.665)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.833 11.365)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M302.049,282.789a1.571,1.571,0,0,1-1.111-2.682,12.209,12.209,0,0,0,0-17.246,1.571,1.571,0,0,1,2.222-2.222,15.354,15.354,0,0,1,0,21.69A1.566,1.566,0,0,1,302.049,282.789Z",
  transform: "translate(-300.477 -260.179)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.119 61.162)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M263.781,418.931H249.822a1.571,1.571,0,1,1,0-3.143h13.958a1.571,1.571,0,1,1,0,3.143Z",
  transform: "translate(-248.251 -415.788)"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.001)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M271.632,192.4a1.571,1.571,0,0,1-1.572-1.571v-6.908a1.571,1.571,0,0,1,3.143,0v6.908A1.571,1.571,0,0,1,271.632,192.4Z",
  transform: "translate(-270.06 -182.345)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.68 4.641)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M220.961,205.973a1.57,1.57,0,0,1-1.362-.786l-3.454-5.983a1.571,1.571,0,0,1,2.722-1.571l3.454,5.983a1.572,1.572,0,0,1-1.359,2.357Z",
  transform: "translate(-215.934 -196.847)"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 17.32)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M183.864,243.066a1.561,1.561,0,0,1-.784-.211L177.1,239.4a1.571,1.571,0,0,1,1.571-2.722l5.983,3.454a1.571,1.571,0,0,1-.788,2.932Z",
  transform: "translate(-176.312 -236.469)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(43.868 4.641)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M314.962,205.973a1.572,1.572,0,0,1-1.359-2.357l3.454-5.983a1.571,1.571,0,1,1,2.721,1.571l-3.454,5.983A1.572,1.572,0,0,1,314.962,205.973Z",
  transform: "translate(-313.392 -196.847)"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(54.019 17.32)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M346.685,243.066a1.571,1.571,0,0,1-.787-2.932l5.983-3.454a1.571,1.571,0,0,1,1.571,2.722l-5.983,3.454A1.562,1.562,0,0,1,346.685,243.066Z",
  transform: "translate(-345.112 -236.469)"
}));

function SvgLightBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.145,
    height: 77.848,
    viewBox: "0 0 63.145 77.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/light-bulb.400d7e69.svg";
export { ForwardRef as ReactComponent };